<section class="contact-us-container">
  <h1 class="visuallyhidden">{{ 'CONTACT_FORM.HEAD_TITLE_DESKTOP' | translate }}</h1>
  <!-- topic -->
  <p
    class="contact-us-topic text-color-blue title-desktop u-text-center"
    [innerHtml]="'CONTACT_FORM.HEAD_TITLE_DESKTOP' | translate"
  ></p>

  <p
    class="contact-us-topic text-color-blue title-mobile u-text-center"
    [innerHtml]="'CONTACT_FORM.HEAD_TITLE_MOBILE' | translate"
  ></p>

  <div class="contact-us-box">
    <div class="contact-us-box__contact-sale">
      <div class="contact-sales">
        <div class="head">{{ 'CONTACT_SALE.CONTACT_SALES' | translate }}</div>
        <div class="detail mobile text-color-dark">{{ 'CONTACT_SALE.CONTACT_SALES_DETAIL' | translate }}</div>
        <div class="detail text-color-dark"
          ><i class="fas fa-phone"></i><a class="text-color-dark" href="tel:020268991">02-026-8991</a></div
        >
        <div class="detail text-color-dark"
          ><i class="fas fa-envelope"></i
          ><a href="mailto:demo@flowaccount.com?Subject=ติดต่อฝ่ายขาย FlowAccount" target="_top" class="text-color-dark"
            >demo&#64;flowaccount.com</a
          ></div
        >
        <div class="detail mobile text-color-dark"
          ><i class="fas fa-clock"></i
          ><div>
            {{ 'CONTACT_SALE.CCS_WORKING_HOUR' | translate }} <br />
            <span>{{ 'CONTACT_SALE.CS_WORKING_HOUR' | translate }}</span></div
          ></div
        >
      </div>
    </div>
    <div class="contact-us-box__contact-form">
      <form
        style="margin-top: 20px"
        action="https://app.flowaccount.com/email/ContactUsEmailFlowAccount"
        method="POST"
        id="contact-form"
        #contactForm
      >
        <div class="row">
          <div class="col-md-12 input-border">
            <div class="form-group name">
              <input
                class="flow-input form-control flow-validate u-font-chatThai"
                type="text"
                placeholder="{{ 'CONTACT_FORM.NAME' | translate }}"
                id="name"
                name="name"
              />
              <p id="p1" class="hidden lbl-valid" translate="{{ 'Please enter your name' }}"></p>
            </div>
            <div class="form-group phone">
              <input
                class="flow-input form-control flow-validate u-font-chatThai"
                type="tel"
                placeholder="{{ 'CONTACT_FORM.PHONE' | translate }}"
                id="phone"
                name="phone"
              />
              <p id="p1" class="hidden lbl-valid" translate="{{ 'Please enter your phone' }}"></p>
            </div>
          </div>
          <div class="col-md-12 input-email">
            <div class="form-group">
              <input
                class="flow-input form-control flow-validate u-font-chatThai"
                type="email"
                placeholder="{{ 'CONTACT_FORM.EMAIL' | translate }}"
                id="email"
                name="email"
              />
              <p id="p2" class="hidden lbl-valid" translate="{{ 'Please enter your email' }}"></p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <textarea
                class="flow-textarea form-control flow-validate u-font-chatThai"
                id="message"
                rows="4"
                placeholder="{{ 'CONTACT_FORM.MESSAGE' | translate }}"
                name="message"
              ></textarea>
              <p id="p4" class="hidden lbl-valid" translate="{{ 'Please enter the Messege' }}"></p>
            </div>
          </div>
        </div>

        <div class="captcha-submit" *ngIf="!scullyRunning && displayCaptcha">
          <div class="recaptcha">
            <re-captcha
              name="captcha"
              (resolved)="resolved($event)"
              siteKey="6LdT1tMUAAAAAOcJfvpP6F7F8Y7RyBwyTi2ajPLm"
              #captchaResponseId
              required
            ></re-captcha>
          </div>

          <div class="row submit-btn">
            <div class="col-md-12 u-font-chatThai">
              <div class="form-group">
                <button
                  id="tracking-contactsales"
                  class="btn-submit-desktop"
                  type="submit"
                  (click)="submitContact()"
                  translate="{{ 'CONTACT_FORM.SEND_MESSAGE' }}"
                  [innerHTML]="captchaResponseId ? '' : 'disabled'"
                >
                </button>
                <button
                  id="tracking-contactsales-mobile"
                  class="btn-submit-mobile {{ translate.currentLang }}"
                  type="submit"
                  (click)="submitContact()"
                  translate="{{ 'CONTACT_FORM.SEND_MESSAGE_MOBILE' }}"
                  [innerHTML]="captchaResponseId ? '' : 'disabled'"
                >
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="recaptcha-check u-font-chatThai">{{ 'CONTACT_FORM.RECAPTCHA_CHECK' | translate }}</div>
      </form>
    </div>
  </div>
</section>
